<template>
  <div>
    <div class="showlabel" v-if="$route.name != 'Paperlist'">
      <div ref="moshi" class="testtype">组件模式：{{ input1 }}</div>
      <div class="testtype">命题方式：{{ input2 }}</div>
    </div>
    <el-card v-loading="loading">
      <div class="main">
        <div class="main_title">
          <i class="iconfont icon-gl_kaoshi3x"></i>
          <h2>【{{ testdata.PaperTitle }}】</h2>
          <p>（共{{ testdata.TestCount }}题，{{ testdata.TotalScore }}分）</p>
        </div>
        <!-- 操作 -->
        <div class="operation_box">
          <el-button @click="addTopicType(0)">
            <i class="iconfont icon-xinzeng"></i>智能添题</el-button
          >
          <el-button
            @click="addTopicType(1)"
            v-if="$parent.testinfomation.PaperMode !== 'unified_exam'"
          >
            <i class="iconfont icon-shoudongtianjia"></i>手动添题</el-button
          >
        </div>
        <!-- 题型小方块 -->
        <div class="flex">
          <div class="topic_box">
            <div v-for="(item, index) in topicArr" :key="index">
              <div
                :class="{ isactive: isact == index }"
                @click="isselect(index)"
              >
                <p>{{ item.Style }}</p>
                <p>({{ item.TestCount }}题,{{ item.TotalScore }}分)</p>
              </div>
            </div>
          </div>
          <!-- 产品修改练习不要 -->
          <el-button @click="getCompareTest('click')" v-if="examState === 'true'" :loading="btnLoading"
            >试题查重</el-button
          >
        </div>

        <!-- 手风琴部分 -->
        <div class="accordion">
          <div class="delete">
            <div class="felx_hader" v-if="topicArr && loading == false">
              <div class="test_hader">
                <h2>
                  {{ testCountTitle }}
                  <!-- 一、A题型、包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。（5分） -->
                </h2>
                <p
                  v-if="input1 === '难易度组卷' && this.topicArr.length != 0"
                  class="difficulty_num"
                >
                  ( <span>简单：{{ topicArr[defualtiscat].easyNum }}题</span>
                  <span>普通：{{ topicArr[defualtiscat].mindleNum }}题</span>
                  <span>困难：{{ topicArr[defualtiscat].hardNum }}题</span> )
                </p>
                <p v-if="testCount() != 0">
                  当前题型重复
                  <span>{{ testCount() }}</span> 题
                </p>
              </div>

              <h3 class="difficulty_hader" v-if="input1 === '难易度组卷'">
                难易度
              </h3>
            </div>

            <el-tooltip
              effect="darkbtn2"
              content="删除题型"
              placement="top-start"
            >
              <i class="iconfont icon-qingkong" @click="deleteStyleType"></i>
            </el-tooltip>
          </div>
          <template v-if="topicArr.length != 0">
            <el-collapse
              v-model="activeName"
              accordion
              v-for="(items, indexs) in topicArr[defualtiscat].testArr"
              :key="indexs"
              class="custom_hover"
            >
              <el-collapse-item :name="indexs" :class="repeatColour(items)">
                <template slot="title" slot-scope="scope">
                  <div
                    v-if="
                      items.TestJSON.TestType === 'ATEST' ||
                      items.TestJSON.TestType === 'XTEST' ||
                      items.TestJSON.TestType === 'TKTEST' ||
                      items.TestJSON.TestType === 'PDTEST' ||
                      items.TestJSON.TestType === 'JDTEST'
                    "
                    :ref="items.TestJSON.ID ? items.TestJSON.ID : items.ID"
                  >
                    <div class="flex_">
                      <template v-if="input1 === '难易度组卷'">
                        <p
                          class="red2"
                          v-html="indexs + 1 + '.' + items.TestJSON.Title"
                        ></p>
                        <p
                          class="difficulty"
                          v-html="items.TestJSON.levelLable"
                        ></p>
                      </template>
                      <p
                        v-else
                        v-html="
                          referimg(
                            indexs + 1 + '.' + items.TestJSON.Title,
                            items.PaperTestID
                          )
                        "
                      ></p>
                    </div>
                  </div>

                  <div
                    v-if="items.TestJSON.TestType === 'BTEST'"
                    class="btest"
                    :ref="items.TestJSON.ID ? items.TestJSON.ID : items.ID"
                  >
                    <div
                      v-for="(itemz, indexz) in items.TestJSON.BTestItem"
                      :key="indexz + '%' + indexs"
                      class="btestcontent"
                      :class="repeatColour(itemz)"
                    >
                      <!-- <p>
                        <span>{{ indexs + 1 }}</span>
                        <span v-html="itemz.Title"></span>
                      </p> -->
                    <div class="flex_">
                      <template v-if="input1 === '难易度组卷'">
                        <p
                          class="red2"
                          v-html="indexs + 1 + '.' + itemz.Title"
                        ></p>
                        <p
                          class="difficulty"
                          v-html="items.TestJSON.levelLable"
                        ></p>
                      </template>
                      <p
                        v-else
                        v-html="
                          referimg(
                            indexs + 1 + '.' + itemz.Title,
                            items.PaperTestID
                          )
                        "
                      >
                    </p>
                    <!-- <p>{{ items.TestJSON }}</p> -->
                    </div>

                      <!-- {{ indexs + 1 + "." + itemz.Title }} -->
                    </div>
                  </div>

                  <div
                    v-if="items.TestJSON.TestType === 'A3TEST'"
                    class="btest"
                    :ref="items.TestJSON.ID ? items.TestJSON.ID : items.ID"
                    :class="repeatColour(items)"
                  >
                    <!-- <p>
                      <span>{{ indexs + 1 }}</span>
                      <span v-html="items.TestJSON.MainTitle"></span>
                    </p> -->
                    <div class="flex_">
                      <template v-if="input1 === '难易度组卷'">
                        <p
                          class="red2"
                          v-html="indexs + 1 + '.' + !items.TestJSON.Title?items.TestJSON.MainTitle:items.TestJSON.Title"
                        ></p>
                        <p
                          class="difficulty"
                          v-html="items.TestJSON.levelLable"
                        ></p>
                      </template>
                      <p
                        v-else
                        v-html="
                          referimg(
                            indexs + 1 + '.' + !items.TestJSON.Title?items.TestJSON.MainTitle:items.TestJSON.Title ,
                            items.PaperTestID
                          )
                        "
                      >
                    </p>
                    <!-- <p>{{ items.TestJSON }}</p> -->
                    </div>
                    <!-- {{ indexs + 1 + "." + items.TestJSON.MainTitle }} -->
                  </div>

                  <div class="down_operation">
                    <el-tooltip
                      v-if="indexs !== 0"
                      effect="darkbtn"
                      content="上移"
                      placement="top-start"
                    >
                      <i
                        class="iconfont icon-cangpeitubiao_shangyi"
                        :class="{ nomove: indexs == 0 }"
                        @click.stop="onmoveup(indexs, items)"
                        :disabled="scope.$index == 0"
                      ></i>
                    </el-tooltip>
                    <template v-if="topicArr.length != 0">
                      <el-tooltip
                        v-if="indexs !== topicArr[0].testArr.length - 1"
                        effect="darkbtn"
                        content="下移"
                        placement="top-start"
                      >
                        <i
                          class="iconfont icon-xiayi"
                          :class="{
                            nomove: indexs == topicArr[0].testArr.length - 1,
                          }"
                          @click.stop="onmovedown(indexs, items)"
                          :disabled="indexs == topicArr[0].testArr.length - 1"
                        ></i>
                      </el-tooltip>
                    </template>

                    <el-tooltip
                      effect="darkbtn2"
                      content="替换题目"
                      placement="top-start"
                    >
                      <i
                        class="iconfont icon-tihuan"
                        @click.stop="replace(items)"
                      ></i>
                    </el-tooltip>
                    <el-tooltip
                      effect="darkbtn"
                      content="删除"
                      placement="top-start"
                    >
                      <i
                        class="iconfont icon-qingkong"
                        @click.stop="deletea(indexs, items)"
                      ></i>
                    </el-tooltip>
                  </div>
                </template>

                <div
                  class="options"
                  v-if="
                    items.TestJSON.TestType === 'ATEST' ||
                    items.TestJSON.TestType === 'XTEST' ||
                    items.TestJSON.TestType === 'TKTEST' ||
                    items.TestJSON.TestType === 'PDTEST' ||
                    items.TestJSON.TestType === 'JDTEST'
                  "
                >
                  <p
                    v-for="(item, index) in items.TestJSON.SelectedItem"
                    :key="index"
                    :class="{
                      istrue:
                        items.TestJSON.Answer.indexOf(sumcount(index)) != -1,
                    }"
                  >
                    {{ sumcount(index) }}、<span
                      v-html="referimg(item, items.PaperTestID)"
                    ></span>
                  </p>
                  <div>
                    答案:
                    <span
                      v-if="input1 !== '难易度组卷'"
                      v-html="
                        referimg(items.TestJSON.Answer, items.PaperTestID)
                      "
                    ></span>
                    <span v-else v-html="items.TestJSON.Answer"> </span>
                  </div>
                </div>

                <div class="options" v-if="items.TestJSON.TestType === 'BTEST'">
                  <p
                    v-for="(itemq, indexq) in items.TestJSON.SelectedItem"
                    :key="indexq"
                    :class="{
                      istrue:
                        answerreduce(items.TestJSON.BTestItem).indexOf(
                          sumcount(indexq)
                        ) != -1,
                    }"
                  >
                    {{ sumcount(indexq) }}、<span
                      v-html="referimg(itemq, items.PaperTestID)"
                    ></span>
                  </p>
                  <div>答案: {{ answerreduce(items.TestJSON.BTestItem) }}</div>
                </div>

                <div
                  class="options"
                  v-if="items.TestJSON.TestType === 'A3TEST'"
                >
                  <div
                    v-for="(iteme, indexe) in items.TestJSON.A3TestItem"
                    :key="indexe"
                  >
                    <h4>（{{ indexe + 1 }}）{{ iteme.Title }}</h4>
                    <p
                      v-for="(itemt, indext) in iteme.SelectedItem"
                      :key="indext"
                      :class="{
                        istrue: iteme.Answer[0].indexOf(sumcount(indext)) != -1,
                      }"
                    >
                      {{ sumcount(indext) }}、<span
                        v-html="referimg(itemt, items.PaperTestID)"
                      ></span>
                    </p>
                    <div v-if="input1 !== '难易度组卷'">
                      答案: {{ iteme.Answer }}
                    </div>
                    <div v-else v-html="'答案: ' + iteme.Answer"></div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>
        </div>
        <!-- 按钮 -->
        <div class="operation">
          <el-button class="succ_btn" @click="cutcoms(0)">上一步</el-button>
          <el-button type="success" class="submit_btn" @click="cutcoms(2)"
            >下一步</el-button
          >
        </div>
      </div>
      <!-- 提示小弹窗 -->
      <div class="delete_view">
        <el-dialog title="温馨提示" :visible.sync="dialogVisible">
          <div class="delete_mian">
            <i class="iconfont icon-tishi1"></i>
            <p v-if="deleteitle == '标题'">确定删除吗？</p>
            <p v-if="deleteitle == '内容'">
              确定删除{{ deleteitem.TestJSON.Title }}吗？
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="deleteaitem">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
//标题的总题数和总分数计算还不完全，。
// import func from 'vue-editor-bridge';
//import { testApi } from "@/services/test";
import editqusetionbank from "@/api/editqusetionbank";
import getstudentlist from "@/api/questionbank";
import loginvuex from "@/store/index";
import { specialTreeatment, facilityProcImg } from "@/utils/topicImg";

//import { set } from "vue/types/umd";
export default {
  props: ["cutcoms"],
  data() {
    return {
      input1: "", //组件模式
      input2: "", //命题方式
      isact: 0, //这是当前点击的活跃的题库类型
      defualtiscat: 0, //切换的题型的索引值
      activeName: "1",
      btnLoading: false,
      loading: true, //加载中，默认是空的
      titleTypeDesc: "", //每个题型的标题
      isShow: false, //上移下移操作
      dialogVisible: false, // 删除提示
      deleteitle: "", //要被删除的题头。 "标题" "内容"
      deleteitem: "", //要被删除的具体
      repeatIDList: [],
      topicArr: [],
      testdata: "", //考试的信息
      num: 1,
      examState: "", // 是否是考试进入
    };
  },
  methods: {
    // 汉字范围一
    numberChinese(number) {
      const strNumber = number.toString();
      const len = strNumber.length;
      let numberCh = "";
      for (let i = 0; i < len; i++) {
        let currentNum = strNumber.substr(i, 1);
        switch (currentNum) {
          case "0":
            numberCh += "零";
            break;
          case "1":
            numberCh += "一";
            break;
          case "2":
            numberCh += "二";
            break;
          case "3":
            numberCh += "三";
            break;
          case "4":
            numberCh += "四";
            break;
          case "5":
            numberCh += "五";
            break;
          case "6":
            numberCh += "六";
            break;
          case "7":
            numberCh += "七";
            break;
          case "8":
            numberCh += "八";
            break;
          case "9":
            numberCh += "九";
            break;
          default:
            numberCh += "*";
        }
      }
      return numberCh;
    },
    isselect(index) {
      this.isact = index;
      this.defualtiscat = index;
    },
    // 上移
    async onmoveup(index, row) {
      var that = this;
      // console.log(that.topicArr[this.defualtiscat].testArr[index]);
      if (index > 0) {
        let parmar = {
          paperID: this.$parent.testinfomation.PaperID,
          testID: row.PaperTestID,
          type: 1, //上移
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
          _examID: this.$parent.testinfomation.ExamID,
        };
        let res = await editqusetionbank.MoveTest(parmar);
        if (res.data.Data[0].result == 1) {
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
        let upDate = that.topicArr[this.defualtiscat].testArr[index - 1];
        that.topicArr[this.defualtiscat].testArr.splice(index - 1, 1);
        that.topicArr[this.defualtiscat].testArr.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    // 下移
    async onmovedown(index, row) {
      var that = this;
      if (index + 1 === that.topicArr[this.defualtiscat].testArr.length) {
        alert("已经是最后一条，不可下移");
      } else {
        let parmar = {
          paperID: this.$parent.testinfomation.PaperID,
          testID: row.PaperTestID,
          type: 0, //上移
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
          _examID: this.$parent.testinfomation.ExamID,
        };
        let res = await editqusetionbank.MoveTest(parmar);
        if (res.data.Data[0].result == 1) {
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
        let downDate = that.topicArr[this.defualtiscat].testArr[index + 1];
        that.topicArr[this.defualtiscat].testArr.splice(index + 1, 1);
        that.topicArr[this.defualtiscat].testArr.splice(index, 0, downDate);
      }
    },
    deleteStyleType() {
      if (this.input1 === "难易度组卷") {
        this.facilityDeleteStyle();
      } else {
        this.deletestyletest();
      }
    },
    facilityDeleteStyle() {
      const parmas = {
        paperStyleID: this.topicArr[this.defualtiscat].PaperStyleID,
        paperID: this.$parent.testinfomation.PaperID,
        _examID: this.$parent.testinfomation.ExamID,
      };
      this.$confirm(
        `确认删除${this.topicArr[this.defualtiscat].Style}吗`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          editqusetionbank.facility_deletestyle(parmas).then((res) => {
            if (res.data.Status == 203) {
              this.$confirm("删除失败，题目总分已不满足及格线", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            } else {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            this.defualtiscat = 0;
            setTimeout(() => {
              this.init();
            }, 500);
          });
        })
        .catch(() => {});
    },
    async deletestyletest() {
      //删除一种类型题目。
      let parmas = {
        paperStyleID: this.topicArr[this.defualtiscat].PaperStyleID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: this.$parent.testinfomation.ExamID,
      };
      this.$confirm(
        `确认删除${this.topicArr[this.defualtiscat].Style}吗`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          editqusetionbank.deletestyle(parmas).then((res) => {
            if (res.data.Status == 203) {
              this.$confirm("删除失败，题目总分已不满足及格线", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            } else {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            this.defualtiscat = 0;
            setTimeout(() => {
              this.init();
            }, 500);
          });
        })
        .catch(() => {});
    },
    // 智能添题和手动添题
    addTopicType(type){
      this.$parent.addtopic = 'addEdit'
      if(type == 0){
        // 智能
        this.cutcoms(4)
      }else{
        // 手动
        this.cutcoms(6)
      }
    },
    //删除
    deletea(index, items) {
      this.deleteitle = "内容";
      items.index = index;
      this.deleteitem = items;
      this.dialogVisible = true;
    },
    async deleteaitem() {
      if (this.input1 === "难易度组卷") {
        const parmas = {
          paperTestID: this.deleteitem.PaperTestID,
          paperID: this.$parent.testinfomation.PaperID,
          _examID: this.$parent.testinfomation.ExamID,
          // hid: JSON.parse(localStorage.getItem("userlist")).hid,
        };
        const { data } = await editqusetionbank.facilityDeleteTest(parmas);
        if (data.Status == 200) {
          this.init();
          this.$message.success("题目删除成功！");
          this.dialogVisible = false;
        } else if (data.Status == 203) {
          this.dialogVisible = false;
          this.$confirm("删除失败，题目总分已不满足及格线", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {});
        } else {
          this.$message({
            message: data.Msg,
            type: "error",
          });

          this.dialogVisible = false;
        }
      } else {
        let parmas = {
          paperTestID: this.deleteitem.PaperTestID,
          examID: this.deleteitem.TestJSON.ID,
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
          // _examID: this.deleteitem.TestJSON.ID, // 3.29 修改此参数应该传试卷ID
          _examID: this.$parent.testinfomation.ExamID,
        };
        let res = await editqusetionbank.DeleteTest(parmas);
        if (res.data.Status == 200) {
          this.init();
          this.$message.success("题目删除成功！");
          this.dialogVisible = false;
          // this.getCompareTest(); // 更新重复试题
        } else if (res.data.Status == 203) {
          this.dialogVisible = false;
          this.$confirm("删除失败，题目总分已不满足及格线", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {});
        } else {
          this.$message({
            message: res.data.Msg,
            type: "error",
          });

          this.dialogVisible = false;
        }
      }
    },
    async getpaperdata() {
      this.loading = true;
      let parmas = {
        paperID: this.$parent.testinfomation.PaperID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: this.$parent.testinfomation.ExamID,
      };

      let res = await editqusetionbank.getPaperStyle(parmas);
      if (res.data.Status == 200) {
        this.$parent.Style["1"] = res.data.Data;
        // setTimeout(() => {
        this.loading = false;
        // }, 500);
      } else {
        this.$message.error(res.data.Msg);
      }
      if (this.input1 === "难易度组卷") {
        this.getStyleTestList();
      } else {
        this.getPaperList();
      }
    },
    // 获取题型
    async getPaperList() {
      let pama = {
        PaperID: this.$parent.testinfomation.PaperID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
      };
      //这里初始化一下全部数据，
      //这里包装最后一步请求的style里面的第1位置数据。
      this.$parent.TestCount = this.$parent.paperinfomation[0].TestCount;
      let resa = await editqusetionbank.getPaperJSON(pama);
      if (resa.data.Status == 200) {
        resa.data.Data.styleArr.map((item) => {
          item.testArr.map((items) => {
            try {
              items.TestJSON = JSON.parse(items.TestJSON);
              // console.log(items.TestJSON, "智能");
            } catch (error) {
              if (String(error).includes("／")) {
                // console.log(items.TestJSON.replace(/[／]/g, "/"));
                return;
              }
              items.TestJSON = JSON.parse(
                items.TestJSON.replace(/[‘]|[""]/g, '"')
              );
            }
          });
        });
        this.testdata = resa.data.Data;
        this.topicArr = resa.data.Data.styleArr;
        const newarr = [];
        if (this.repeatIDList) {
          this.topicArr.forEach((item) => {
            item.num = [];
            if (item.testArr) {
              item.testArr.forEach((zitem) => {
                if (this.repeatIDList.includes(zitem.TestJSON.ID) == true) {
                  item.num.push(zitem.TestJSON.ID);
                }
              });
            }
          });
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(resa.data.Msg);
      }
    },
    // 获取难易度题型
    async getStyleTestList() {
      let pama = {
        PaperID: this.$parent.testinfomation.PaperID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
      };
      this.$parent.TestCount = this.$parent.paperinfomation[0].TestCount;
      const { data } = await editqusetionbank.getStyleTest(pama);
      if (data.Status == 200) {
        data.Data.styleArr.map((item) => {
          item.testArr.map((items) => {
            // console.log(JSON.parse(items.TestJSON),'???');
            try {
              items.TestJSON = JSON.parse(items.TestJSON);
              // console.log(items.TestJSON,'TestJSON');
            } catch (error) {
              console.log(error);
              // if (String(error).includes("／")) {
              //   // console.log(items.TestJSON.replace(/[／]/g, "/"));
              //   return;
              // }
              // items.TestJSON = items.TestJSON.replace(/\\"/g, '"');
              // items.TestJSON = JSON.parse(
              //   items.TestJSON.replace(/[‘]|[""]/g, '"')
              // );
            }
          });
        });
        // 难易度字段名不一样兼容处理
        data.Data.styleArr.forEach((item) => {
          item.easyNum = 0;
          item.mindleNum = 0;
          item.hardNum = 0;
          item.testArr.forEach((zitem) => {
            // console.log(typeof zitem.TestJSON === "object");
            if (
              (typeof zitem.TestJSON === "object") == true &&
              zitem.TestJSON !== null
            ) {
              zitem.TestJSON.TestType = zitem.TestJSON.Type;
              zitem.TestJSON.ID = zitem.TestJSON.AllTestID;
              zitem.TestJSON.Title = facilityProcImg(
                zitem.TestJSON.Title,
                item.AppEName
              );
              zitem.TestJSON.Answer = facilityProcImg(
                zitem.TestJSON.Answer,
                item.AppEName
              );
              // console.log(zitem.TestJSON.SelectedItem, "zitem.TestJSON");
              if (zitem.TestJSON.SelectedItem) {
                zitem.TestJSON.SelectedItem = zitem.TestJSON.SelectedItems.map(
                  (citem) => {
                    return facilityProcImg(citem.Content, item.AppEName);
                  }
                );
              }
              if (
                zitem.TestJSON.Type === "A3TEST" ||
                zitem.TestJSON.Type === "BTEST"
              ) {
                zitem.TestJSON.MainTitle = facilityProcImg(
                  zitem.TestJSON.FrontTitle,
                  item.AppEName
                );
                const obj = {
                  ID: zitem.TestJSON.ChildTableID,
                  // Title: zitem.TestJSON.Title,
                  Title: zitem.TestJSON.Title,
                  Explain: zitem.TestJSON.Explain,
                  TestPoint: zitem.TestJSON.TestPoint,
                  SelectedItem: zitem.TestJSON.SelectedItem,
                  Answer: [zitem.TestJSON.Answer],
                };
                zitem.TestJSON.Sorting = zitem.Sorting;
                if (zitem.TestJSON.Type === "A3TEST") {
                  zitem.TestJSON.A3TestItem = []; // A3题型数组
                  zitem.TestJSON.A3TestItem.push(obj);
                } else if (item.Type === "BTEST") {
                  zitem.TestJSON.BTestItem = []; // B题型数组
                  zitem.TestJSON.BTestItem.push(obj);
                }
                // console.log(zitem.TestJSON.A3TestItem, "???");
              }
              // zitem.TestJSON.SelectedItem = zitem.TestJSON.SelectedItems;
              // 难易度判断 easyNum   中等：mindleNum  困难：hardNum
              zitem.TestJSON.levelNum = Number(zitem.TestJSON.ReplyRate) * 10; //把小数点变整数好比较
              if (zitem.TestJSON.levelNum <= 3) {
                //简单
                zitem.TestJSON.level = "easy";
                zitem.TestJSON.levelLable = "简单";
                item.easyNum++;
              } else if (zitem.TestJSON.levelNum <= 6) {
                //中等
                zitem.TestJSON.level = "mindle";
                zitem.TestJSON.levelLable = "普通";
                item.mindleNum++;
              } else {
                //困难
                zitem.TestJSON.level = "hard";
                zitem.TestJSON.levelLable = "困难";
                item.hardNum++;
              }
              if (zitem.TestJSON.SelectedItems instanceof Array == true) {
                zitem.TestJSON.SelectedItem = zitem.TestJSON.SelectedItems.map(
                  (item) => {
                    return item.Content;
                  }
                );
              }
            } else {
              console.log(zitem.TestJSON, "错误的");
            }
          });
        });
        this.testdata = data.Data;
        console.log(this.testdata,'this.testdata');
        
        this.topicArr = data.Data.styleArr;
        console.log(this.topicArr, "数据");
        if (this.repeatIDList) {
          this.topicArr.forEach((item) => {
            item.num = [];
            if (item.testArr) {
              item.testArr.forEach((zitem) => {
                if (this.repeatIDList.includes(zitem.TestJSON.ID) == true) {
                  item.num.push(zitem.TestJSON.ID);
                }
              });
            }
          });
        }
        console.log(this.topicArr[this.defualtiscat].testArr);
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Msg);
      }
    },
    replace(items) {
      // isact
      // console.log(this.testdata.styleArr[this.isact]);
      this.$parent.plateType = this.testdata.styleArr[this.isact]; // 记录当前替换的题型板块
      this.$parent.isselecttest = items;
      this.cutcoms(8);
    },
    numberToUpperCase(textIndex) {
      let newString = "";
      let newTextIndex = textIndex + 1 + "";

      function sum(value, index) {
        var newValue = "";
        if (textIndex === 9) {
          return !index ? "十" : "";
        }
        let isSeat = ~~textIndex > 9 && ~~textIndex < 19;
        switch (~~value) {
          case 1:
            newValue = !index ? (isSeat ? "" : "一") : "十一";
            break;
          case 2:
            newValue = !index ? (isSeat ? "" : "二") : "十二";
            break;
          case 3:
            newValue = !index ? (isSeat ? "" : "三") : "十三";
            break;
          case 4:
            newValue = !index ? (isSeat ? "" : "四") : "十四";
            break;
          case 5:
            newValue = !index ? (isSeat ? "" : "五") : "十五";
            break;
          case 6:
            newValue = !index ? (isSeat ? "" : "六") : "十六";
            break;
          case 7:
            newValue = !index ? (isSeat ? "" : "七") : "十七";
            break;
          case 8:
            newValue = !index ? (isSeat ? "" : "八") : "十八";
            break;
          case 9:
            newValue = !index ? (isSeat ? "" : "九") : "十九";
            break;
          case 0:
            newValue = "十";
            break;
          default:
            break;
        }
        return newValue;
      }

      for (let i = 0; i < newTextIndex.length; i++) {
        newString += sum(newTextIndex.substring(i, i + 1), i);
      }
      return newString;
    },
    async getCompareTest(type) {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        examID: this.$parent.testinfomation.ExamID,
      };
      this.btnLoading = type ? true : false;
      const { data } = await getstudentlist.compareTest(obj);
      if (data.Status == 200) {
        console.log(data);
        this.repeatIDList = data.Data.repeatIDList;
        if (type) {
          // 点击触发时
          if (data.Data.repeatCount != 0) {
            // 有重复的
            this.$confirm(
              `经检测，您创建的考试“${this.testdata.PaperTitle}”存在重复试题${data.Data.repeatCount}道。已经为您标记出重复试题。`,
              "温馨提示",
              {
                confirmButtonText: "前往查看",
                cancelButtonText: "不做处理",
                closeOnClickModal: false,
                type: "warning",
              }
            )
              .then(() => {
                // 过滤找出当前row
                console.log(this.defualtiscat, this.topicArr);
                console.log(this.topicArr[this.defualtiscat].testArr);
                let idx = "";
                // 找到第一个错题块,再匹配滑动到第一错题
                this.$nextTick(() => {
                  this.topicArr.forEach((item, index) => {
                    item.testArr.forEach((zitem, zindex) => {
                      if (zitem.TestJSON.ID == this.repeatIDList[0]) {
                        this.defualtiscat = index;
                        this.isact = index;
                        // idx = "14479368";
                        idx = zitem.TestJSON.ID ? zitem.TestJSON.ID : zitem.ID;
                        console.log(zindex);
                      }
                    });
                  });
                  setTimeout(() => {
                    this.$refs[idx][0].scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }, 500);
                  // console.log(idx, this.$refs[idx]);
                });
                return;
                const newarr = this.topicArr[this.defualtiscat].testArr.filter(
                  (item) => {
                    return item.isRepeat == true;
                  }
                );
                console.log(newarr[0], "?????");
                if (newarr[0]) {
                  this.replace(newarr[0]);
                  sessionStorage.removeItem("repeaObj");
                }
              })
              .catch(() => {
                sessionStorage.removeItem("repeaObj");
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            // sessionStorage.setItem('repeaObj',JSON.stringify(repeaObj))
            // this.$parent.$parent.$children[0].removeWeight(); // 重复弹窗
          } else {
            this.$message({
              message: "当前检测并无重复试题",
              type: "warning",
            });
            sessionStorage.removeItem("repeaObj");
          }
          setTimeout(() => {
            this.btnLoading = false;
          }, 500);
        }
      } else {
        this.$message.error(data.Msg);
      }
    },
    async init() {
      // 难易度暂时不能查重
      if (this.input1 !== "难易度组卷") {
        await this.getCompareTest();
      }
      await this.getpaperdata();
    },
  },
  computed: {
    sumcount() {
      return function (index) {
        let a = index;
        switch (a) {
          case 0:
            return "A";
          case 1:
            return "B";
          case 2:
            return "C";
          case 3:
            return "D";
          case 4:
            return "E";
          case 5:
            return "F";
          case 6:
            return "G";
          case 7:
            return "H";
          case 8:
            return "I";
          case 9:
            return "J";
          case 10:
            return "K";
        }
        return a;
      };
    },
    referimg() {
      return function (params, id) {
        if (this.input1 === "难易度组卷") {
          return params;
        } else {
          if (params.indexOf("[Img") == "-1") {
            return params;
          } else {
            let a = params.replace(
              /\[Img/g,
              "<img src='https://testimages.ksbao.com/tk_img/Img"
            );
            if (a.indexOf("~") != "-1") {
              let codeindex = a.lastIndexOf(".");
              a = a.replace(
                a[codeindex - 1],
                "%" + a[codeindex - 1].charCodeAt().toString(16)
              );
            }
            if (String(id).length >= 32) {
              let imgurl = sessionStorage.getItem("ImgUrl"); // 图片正式还是测试地址
              a = params.replace(
                /\[Img/g,
                `<img src='${imgurl}/${JSON.parse(loginvuex.state.hid)}/`
              );
            }
            return a.replace(/\]/g, "'>");
          }
        }
      };
    },
    testCountTitle() {
      if (this.topicArr.length != 0) {
        return (
          this.numberToUpperCase(this.defualtiscat) +
          "、" +
          this.topicArr[this.defualtiscat].Style
        );
      } else {
        return "";
      }
    },
    testCount() {
      return function () {
        if (this.topicArr.length != 0 && this.topicArr[this.defualtiscat].num) {
          return this.topicArr[this.defualtiscat].num.length;
        } else {
          return 0;
        }
      };
    },
    answerreduce() {
      return function (params) {
        //      console.log(params);
        if (params.length == 1) {
          return params[0].Answer[0]; //这个地方暂时只用数组内的一个答案为
        }
        let res = params.reduce((first, scend) => {
          if (typeof first === "string") {
            return first + scend.Answer[0];
          } else {
            return first.Answer + scend.Answer;
          }
        });
        return res;
      };
    },
    // 重复试题标记背景颜色
    repeatColour() {
      return function (row) {
        // if(row.TestJSON.BTestItem){
        // console.log(row,'B',row.TestJSON?.ID,row.ID);
        // }
        // console.log(
        //   row,
        //   this.topicArr[this.defualtiscat].testArr,
        //   this.repeatIDList
        // );
        // this.repeatIDList // 重复数组
        if (this.repeatIDList.includes(row.TestJSON?.ID || row.ID) == true) {
          row.isRepeat = true;
          return "red";
        } else {
          row.isRepeat = false;
          return "";
        }
      };
    },
  },
  mounted() {},
  activated() {
    this.input1 = this.$parent.testinfomation.PaperModeExam; //组卷模式
    this.input2 = this.$parent.testinfomation.PaperModeName; //组卷方式
    this.examState = sessionStorage.getItem("examState"); // 是否是考试进入
    // this.loading = true;
    // this.getCompareTest();
    // const txt = "监测P[XBET.gif]CO[XB2.gif]对以下情况哪几项具有临床意义";
    // const appEName = "GJZC_ZG_MZTX";
    // console.log(facilityProcImg(txt, appEName), "解析图片");
    this.$parent.addtopic = null
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.red {
  ::v-deep .el-collapse-item__header {
    background: #d8edff !important;
    color: red;
    font-weight: bold;
    width: 100%;
    height: 100%;
  }
}
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    //background-color: antiquewhite;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    margin-left: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 22px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.operation {
  display: flex;
  margin-top: 60px;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-card__body {
  padding: 0px !important;
  border-radius: 10px;
}
.main {
  .main_title {
    display: flex;
    align-content: center;
    border-bottom: 1px solid #eeeeee;
    padding: 30px 24px 20px 24px;

    i {
      display: inline-block;
      font-size: 24px;
      color: #369eff;
      margin-right: 10px;
    }
    h2 {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    p {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      transform: translateY(2px);
    }
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > .el-button {
      margin-right: 24px;
      background: #1890ff;
      color: #fff;
    }
  }
  .topic_box {
    padding: 24px;
    min-height: 145px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    flex-wrap: wrap;
    div {
      width: 116px;
      height: 100px;
      margin-right: 24px;
      margin-bottom: 12px;
      position: relative;
      background-image: url("../../../../../../assets/topic/rec2.png");
      // border-radius:5px 20px 5px 5px ;
      // border: 1px solid #1890FF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .isactive {
        background-image: url("../../../../../../assets/topic/rec3.png") !important;
        p {
          color: #ffff;
        }
      }
      &:hover {
        cursor: pointer;
        background-image: url(../../../../../../assets/topic/rec1.png);
        background-size: cover; // 背景图片铺满整个容器
        p {
          color: #1890ff;
        }
      }
      img {
        display: inline-block;
        width: 116px;
        height: 100px;
      }
      div {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      p:nth-child(1) {
        margin-bottom: 10px;
      }
    }
  }
  .accordion {
    .delete {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 70px;
      line-height: 26px;
      background: #d8edff;
      padding: 21px 24px;
      box-sizing: border-box;
      h2 {
        opacity: 1;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      i {
        font-size: 32px;
      }
    }
  }
}
.istrue {
  color: #1890ff !important;
}
::v-deep .el-collapse-item__header {
  padding: 8px 14px;
  // height: 50px !important;
  // line-height: 50px  !important;
  font-size: 15px;
  font-weight: 400;
  border: 1px solid #70bafe;
  position: relative;
  height: auto;
  line-height: 15px;
  &:hover {
    background: #eff7ff;
  }
  .down_operation {
    position: absolute;
    right: 53px;
    display: none;
    //  top: 0;
    i {
      display: inline-block;
      margin-right: 30px;
      color: #1890ff;
      font-size: 24px;
    }
  }
}
::v-deep .el-collapse-item__wrap {
  // border-bottom: 1px solid #70bafe !important;
  border: none;
}
::v-deep .el-collapse-item__arrow {
  font-size: 24px !important;
  // margin: 0;
}
.options {
  padding: 14px 26px;
  p {
    color: #999999;
    margin-bottom: 12px;
  }
  div {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
// 按钮
.operation_box {
  display: flex;
  opacity: 1;
  height: 88px;
  border-radius: 4px;
  padding: 24px;
  border-bottom: 1px solid #eeeeee;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 115px;
    height: 40px;
    margin-right: 24px;
    color: #ffffff;
    letter-spacing: 1px;
    border: none !important;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
  }
  .el-button:nth-child(2) {
    background: #ee6717;
  }
  .el-button:nth-child(3) {
    background: #64b5ff;
  }
}
::v-deep.el-collapse {
  border-bottom: none !important;
}
// 弹窗
.delete_view {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 50px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 24px 30px 24px;
  }
  .delete_mian {
    display: flex;
    box-sizing: border-box;
    i {
      display: inline-block;
      //   width: 50px;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      // margin: 0 auto;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .el-dialog {
  width: 441px;
  min-height: 188px;
  border-radius: 5px;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
  }
}
.hidden {
  display: none;
}
.According {
  display: block;
}
.custom_hover:hover {
  .down_operation {
    display: block;
  }
}
.nomove {
  opacity: 0;
  cursor: auto;
}
.btest {
  // background-color: #ffffff;
  cursor: auto;
  width: 85%;
  line-height: 25px;
}
.btestcontent {
  margin-top: 8px;
}
.felx_hader {
  width: 100%;
  display: flex;
  align-items: center;
  > p {
    margin-left: 24px;
    > span {
      color: red;
    }
  }
  .difficulty_hader {
    // margin-left: 50%;
    letter-spacing: 2px;
  }
}
.test_hader {
  width: 73%;
  display: flex;
  align-items: center;
}
.difficulty_num {
  padding-left: 50px;
  > span {
    margin-right: 22px;
    &:nth-child(3) {
      margin-right: 0px;
    }
  }
}
.red2 {
  // border: 1px solid #000;
  width: 100%;
}
.flex_ {
  width: 65vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border: 1px solid red;
  .difficulty {
    width: 100px;
    margin-left: 100px;
  }
}
</style>
